import React, { useState } from 'react'
import CertificatePerk from './CertificatePerk'
import { faChevronDown, faChevronUp, faCircleCheck } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useEffect } from 'react'
import { selectUserName } from '../../../redux/personaliseLessons/nameSlice'
import { useSelector } from 'react-redux'
import { selectAuthentication } from '../../../redux/personaliseLessons/authenticationSlice'


const CertificateSection = ({ courseModuleContent }) => {

    const [showCertificate, setShowCertificate] = useState(true)
    const [ microSkills, setMicroSkills ] = useState([])
    const name = useSelector(selectAuthentication)
    const name1 = useSelector(selectUserName)
    const userName = name?.userName || name1
    
    useEffect(() => {
        setTimeout(() => setShowCertificate(false), 500)
    }, [])

    useEffect(() => {
        setMicroSkills(courseModuleContent?.map((item) => item?.module_name))
        setTimeout(() => setShowCertificate(true), 2000)
    }, [courseModuleContent])

    
    return (
        <div className='mt-3 bg-[#2D4F71] p-3 rounded-xl' >
            <div className='flex items-center justify-between cursor-pointer' onClick={() => setShowCertificate(!showCertificate)}>
                <div className='flex'>
                    <FontAwesomeIcon icon={faCircleCheck} className='text-[#55A47E] bg-white rounded-full text-xl mr-2'/>
                    <p className='font-medium'>Industry Recognised Certifications</p>
                </div>
                {!showCertificate ?  <FontAwesomeIcon icon={faChevronDown} className='text-xl font-extrabold ml-2' onClick={() => setShowCertificate(!showCertificate)}/> : <FontAwesomeIcon icon={faChevronUp} className='text-xl font-extrabold ml-2 mt-1.5'/>}
            </div>
            {showCertificate && 
                <CertificatePerk selectedDomain={microSkills} name={userName}/>
            }
        </div>
    )
}

export default CertificateSection
